/**
 * Schedule template is a hexadecimal-encoded bit-array.
 *
 * Each bit represents 15 minutes:
 *
 * 1 means working time;
 * 0 means free time.
 *
 * Each 12 bytes represent 24 hours,
 * where first 12 bytes represent Monday, next ones Tuesday, etc.
 *
 * Since each byte is encoded by two chars,
 * each char in the template represents an hour.
 *
 * For example, the following template encodes Monday-Friday work week
 * with 8:00-12:00 and 13:00-17:00 working hours:
 *
 * schedule = [
 *   "00000000ffff0ffff0000000"  # Monday
 *   "00000000ffff0ffff0000000"  # Tuesday
 *   "00000000ffff0ffff0000000"  # Wednesday
 *   "00000000ffff0ffff0000000"  # Thursday
 *   "00000000ffff0ffff0000000"  # Friday
 *   "000000000000000000000000"  # Saturday
 *   "000000000000000000000000"  # Sunday
 * ]
 */

// working days Mo-Fr 09:00-12:00 & 13:00-17:00
export const DEFAULT_SCHEDULE = [
  '000000000fff0ffff0000000',
  '000000000fff0ffff0000000',
  '000000000fff0ffff0000000',
  '000000000fff0ffff0000000',
  '000000000fff0ffff0000000',
  '000000000000000000000000',
  '000000000000000000000000',
].join('');

// 09:00-12:00
export const DEFAULT_INTERVAL = [540, 720];

export const SCHEDULE_SLOT_DURATION = 15; // minutes

export const DAY_SLOTS_COUNT = (24 * 60) / SCHEDULE_SLOT_DURATION;
